export default __webpack_public_path__ + "static/media/instagram.b5a82b87.svg";